module.exports = __webpack_public_path__ + "static/media/lefttn.ffac729c.png";